'use strict';

export const UPDATE_PRODUCT_MODAL = 'UPDATE_PRODUCT_MODAL';
export const UPDATE_PRODUCT_MODAL_LOADING_STATUS = 'UPDATE_PRODUCT_MODAL_LOADING_STATUS';

// 更新弹出框状态（显示、隐藏）
export function updateProductModal(modalItme = null, visible = false, opType = 'ADD') {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_PRODUCT_MODAL,
      modalItme,
      visible,
      opType,
    });
  }
}

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_PRODUCT_MODAL_LOADING_STATUS,
      loading,
    });
  }
}